module.exports = __webpack_public_path__ + "static/media/stofferingen-19.1e86fb80.jpg";